module.exports = require("./kam.d.ts");